const PROBED_KEY = 'sso_probed';

// The idp holds the shared session. A user who signed in to data hub already has one, so bounce
// through the idp once to pick up a swims session. Returns true when the browser is leaving.
// data-hub-ui carries its own copy, because it does not depend on ui-web.
export function trySilentSso() {
  const params = new URLSearchParams(window.location.search);

  // the idp refused. stay anonymous and drop the marker so a reload does not carry it.
  if (params.get('sso') === 'none') {
    sessionStorage.setItem(PROBED_KEY, '1');
    params.delete('sso');

    const query = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (query ? `?${query}` : ''));

    return false;
  }

  if (sessionStorage.getItem(PROBED_KEY)) {
    return false;
  }

  // set the flag before the redirect. a probe that never comes back must not loop.
  sessionStorage.setItem(PROBED_KEY, '1');

  const returnUrl = window.location.pathname + window.location.search;
  window.location.href = `/bff/login/silent?returnUrl=${encodeURIComponent(returnUrl)}`;

  return true;
}
